import { Box, Table, TableCell, TableRow, alpha, styled } from '@mui/material';

export const DictionaryDetailsTitleContainer = styled('span')(() => ({
  cursor: 'pointer'
}));

export const DictionaryDetailTableContainer = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto'
}));

export const DictionaryDetailTable = styled(Table)(() => ({
  tableLayout: 'fixed',
  minWidth: '700px'
}));

export const DictionaryDetailTableRow = styled(TableRow, { shouldForwardProp: prop => !['isNew'].includes(prop) })(({ theme, isNew }) => ({
  ...(isNew && {
    marginBottom: '2px',
    '& td': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1)
    }
  }),
  height: '60px'
}));

export const DictionaryDetailTableCell = styled(TableCell)(() => ({
  paddingBlock: 0
}));
